/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quantity: NonNullable<unknown> }} Report_Lines_Unit_Seat_MonthInputs */



/**
* | output |
* | --- |
* | "{quantity} seat-months" |
*
* @param {Report_Lines_Unit_Seat_MonthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_lines_unit_seat_month = /** @type {((inputs: Report_Lines_Unit_Seat_MonthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Lines_Unit_Seat_MonthInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.quantity} Platzmonate`)
	return /** @type {LocalizedString} */ (`${i?.quantity} seat-months`)
});